import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsconscient } from "../../../../data/projects/Conscient/data";
import { projectsbirla } from "../../../../data/projects/Birla/data";

export const BirlaArika = () => {
  const {
    arika: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectsbirla;

  return (
    <>
      <Helmet>
        <title>Birla Arika Sector 31 Gurgaon – Luxury 4 BHK Homes by Birla Estates</title>
        <meta name="description" content="Birla Arika, a premier residential project by Birla Estates in Sector 31, Gurgaon. Experience unparalleled luxury with spacious 4BHK homes, top-notch amenities, and prime connectivity." />
        <meta name="keywords" content="Birla Arika, Birla Arika Sector 31 Gurgaon, Birla Arika 4 BHK, Birla Estates, luxury homes Gurgaon, real estate Gurgaon, Birla Arika amenities" />
        <link rel="canonical" href="https://propertystation.in/birla-arika-sector-31-gurugram" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
